export const onboarding_style = {
  rootSx: {
    p: 3,
  },
};
